import { useMemo } from 'react';

import BoardContextProvider from 'lib/context/BoardContext/BoardContextProvider';
import { useBillingOverview } from 'lib/hooks/queries/widgets/useBilling';

import GrandTotal from 'components/practice/BeyondBilling/Overview/widgets/GrandTotal';
import ViewTabs from 'components/shared/AgTablePage/components/ViewTabs';
import { createQueryFilters } from 'components/shared/AgTablePage/lib/createQueryFilters';
import Board from 'components/shared/CustomizableBoard/Board';
import HeaderButton from 'components/shared/CustomizableBoard/HeaderButton';
import Filters from 'components/shared/Filters/Filters';
import FilterActions from 'components/shared/Filters/components/FilterActions';
import { useReactFilters } from 'components/shared/Filters/hooks/useReactFilters';
import Header from 'components/shared/Header/Header';

import { defaultFilters } from './lib/helpers';
import WidgetRenderer from './widgets/WidgetRenderer';

const name = 'beyond_billing_overview';

const widgets = {
  grand_total: GrandTotal,
  billing_claims: WidgetRenderer,
  billing_era_eob: WidgetRenderer,
  billing_invoices: WidgetRenderer,
  billing_superbills: WidgetRenderer
};

export default function BeyondBillingOverview() {
  const {
    filters,
    filtersInitialized,
    initialFilters,
    isEditingFilter,
    resetFilters,
    updateFilters,
    changeFilters
  } = useReactFilters({
    name,
    defaultFilters
  });

  const newFilters = useMemo(() => createQueryFilters(filters), [filters]);

  const { data } = useBillingOverview({
    params: { filters: newFilters },
    dependencies: [filters],
    options: { enabled: filtersInitialized }
  });

  return (
    <BoardContextProvider board="beyond_billing_overview" cols={{ lg: 4, md: 2, sm: 2 }}>
      <Board
        wrapperClassName="overflow-auto"
        rootClassName="h-full"
        widgets={widgets}
        overview={data}
        showInfoInRecordings={true}>
        <HeaderButton
          header={() => (
            <Header title="Reporting Overview" className="w-full !border-b-0">
              <ViewTabs
                category="beyond_billing_overview"
                title="Reporting Overview"
                filters={filters}
                updateFilters={updateFilters}
                resetFilters={resetFilters}
              />
            </Header>
          )}
        />
        <div className="outline-b flex items-center justify-between gap-2 bg-white px-4 py-2 outline-1 outline-offset-[-1px] outline-neutral-200">
          <Filters
            defaultFilters={defaultFilters}
            filters={filters}
            changeFilters={changeFilters}
          />
          <div className="flex h-full flex-wrap items-start gap-2">
            {filters && (
              <FilterActions
                filters={filters}
                initialFilters={initialFilters}
                changeFilters={changeFilters}
                category="beyond_billing_overview"
                isEditingFilter={isEditingFilter}
              />
            )}
          </div>
        </div>
      </Board>
    </BoardContextProvider>
  );
}
